import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import InternalTxnDetailPagePopup from "../../../../components/InternalTransactionMain/InternalTxnDetailPopup";
import Loader from "../../../../components/Loader/Index";
import SecondaryButton from "../../../../components/_utils/CommonButtons/SecondaryButton";
import CommonToast from "../../../../components/_utils/CommonToast";
import ApprovalTopNavComponent from "../../../../components/_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import InternalTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalTxnDeclinePopup";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  internalTxnMultiApproval,
  resetITMultiRejectApprovalData,
} from "../../../../redux/features/internalTransaction/internalTransactionSingleApproval";
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { IntervalConfiguration } from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import globalText from "../../../../utils/globalText";
import "./index.css";

const InternalMultiApprovalTxnDetails = ({ state }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const services = useSelector((state) => state.refreshToken.services);
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [refreshId, setRefreshId] = useState("");
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(null);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [isApprovalError, setIsApprovalError] = useState(false);
  const { showReloginModal } = useSelector((state) => state.login);
  const [showMultiTxnDetailPop, setShowMultiTxnDetailPop] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const conditionVarLengthZero = 0;
  const TimestampConverter = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    return formattedDate;
  };

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(
        storedSelectedApproval?.selectedTransactions || [],
      );
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  const handleRefresh = (e, id, txnId, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(id);
      setRefreshId(txnId);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== txnId),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance,Admin",
        },
      });
    }
  };

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      setTimeout(() => {
        UniversalRefreshToast();
      }, IntervalConfiguration?.intervalExtraSmall);
    } else if (createTransactionBankRefreshData?.status) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, 500);
      if (refreshId) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshId),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }, 100);
      if (refreshId) {
        setFailedRefreshId((prev) => [...prev, refreshId]);
      }
    }
    if (createTransactionBankRefreshData) {
      let data = transactionFilterData.map((txn) => {
        if (
          txn?.owner_account_id ===
          createTransactionBankRefreshData?.owner_accounts[0]?.owner_account_id
        ) {
          return {
            ...txn,
            owner_account_balance:
              createTransactionBankRefreshData?.owner_accounts[0]
                ?.owner_account_balance,
            owner_account_balance_last_fetched_at_in_words:
              createTransactionBankRefreshData?.owner_accounts[0]
                ?.owner_account_balance_last_fetched_at_in_words,
          };
        }
        return txn;
      });

      setTransactionFilterData(data);
      const selectedData = {
        selectedSendTransactions: data,
        selectedTransactions: transactionFilterID,
      };

      sessionStorage.setItem("selectedData", JSON.stringify(selectedData));
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    refreshAnimation,
    refreshId,
    dispatch,
    transactionFilterID,
    transactionFilterData,
  ]);
  let total = transactionFilterData?.reduce((acc, obj) => {
    return acc + parseInt(obj?.amount);
  }, 0);

  const handleOpenPopup = (id) => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const updateAllAccounts = (updatedAccounts) => {
    setAllBeneTxnAccounts(updatedAccounts);
  };

  const handleTxnApproval = async (id) => {
    setLoading(true);
    UniversalRefreshToast("Approving transaction");

    if (transactionFilterID.length) {
      dispatch(resetITMultiRejectApprovalData());
      const data = await dispatch(internalTxnMultiApproval(id));

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === 500) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }, 1000);
        }
        if (data?.payload?.errors?.user_unauthorized?.[0]) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "VBeneficiaryTxn",
              },
            });
          }, 1000);
        } else if (data.payload.status === true) {
          const selectedData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem("selectedData", JSON.stringify(selectedData));
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/success",
          );
        } else if (data.payload.status === false) {
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/error",
          );
          setIsApprovalError(true);
        }
      }, 2000);
    }
  };

  const openMultiTxnDetailModal = () => {
    setShowMultiTxnDetailPop(true);
  };

  const closeInternalTxnDetailModal = () => {
    setShowMultiTxnDetailPop(false);
  };

  useEffect(() => {
    if (isApprovalError && showReloginModal === false) {
      navigate(
        "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/error",
      );
    }
  }, [showReloginModal, isApprovalError, navigate]);

  useEffect(() => {
    const hasInsufficientFunds = transactionFilterData.some(
      (txn) => parseInt(txn?.amount) > parseFloat(txn?.owner_account_balance),
    );
  }, [transactionFilterData]);

  const isNoTransactionSelected =
    transactionFilterData.length === conditionVarLengthZero;

  const service =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  return (
    <>
      {showPopup && (
        <InternalTxnDeclinePopup
          handleClose={handleClosePopup}
          txnId={transactionFilterID}
          allTxnData={transactionFilterData}
          updateAllTxn={updateAllAccounts}
          flow="multiApproval"
        />
      )}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {showMultiTxnDetailPop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <InternalTxnDetailPagePopup
              closeInternalTxnDetailModal={closeInternalTxnDetailModal}
              internal_txn_id={txnId}
              type={"internal_txn_detail_modal"}
              setShowInternalTxnDetailPop={setShowMultiTxnDetailPop}
              error_msg={errorMessage}
              setErrorMessage={setErrorMessage}
            />
          </div>
        )}
        {loading && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        )}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>

        <div className="int-txn-mutli-container">
          <ApprovalTopNavComponent
            handleBack={() => navigate(-1)}
            topNavCtaBtn1Needed={false}
            isFormattingNotRequired={false}
            topNavHeader={total}
            topNavSubText="Total amount"
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject transactions",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleOpenPopup(transactionFilterID);
                }
              },
              enabledBgColor: "var(--failed)",
              enabledTextColor: "var(--text-primary)",
              icon: "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg",
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve transactions",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleTxnApproval(transactionFilterID);
                }
              },
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: "https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg",
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            BottomHeader={`Post Approval Process`}
            BottomSubText={`Once approved, transaction distribution will get created and
                auto settled using selected source account. If there are
                insufficient funds, the transaction will settle once the source
                account is refilled, and distribution will be initiated
                thereafter.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                title: "Refresh schedules",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div className="int-txn-mutli-select-data-card int-txn-multi-details-mob capitalize">
          <h4>
            {globalText?.SELECTED_TRANSACTION_COUNT} (
            {transactionFilterData?.length})
          </h4>
          <div className="standard-card-alignment gap-gap-md int-txn-mutli-card-list">
            {transactionFilterData?.map((txn, i) => {
              return (
                <div
                  className=""
                  key={txn?.txn_id || i}
                >
                  <CardContainer
                    isNoCursorRequired={true}
                    isDisabled={false}
                    isSelected={false}
                    onClickHandler={(e) => {
                      e.stopPropagation();
                    }}
                    isNoHoverRequired={true}
                  >
                    <card-body>
                      <TextWithIcon
                        type={"Amount"}
                        fontWeight={"semibold"}
                        text={txn?.amount}
                        textColor={"var(--settled)"}
                        subText={"Transaction amount"}
                        iconComponentArray={[
                          ...(txn?.confidential_transaction === "Y"
                            ? [
                                {
                                  icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                                  title: "confidential",
                                  isDisabled: false,
                                },
                              ]
                            : []),
                        ]}
                      />

                      <AccountNumberWithBank
                        sourceAccNo={txn?.owner_account_bank_acc_no}
                        destinationAccNo={txn?.internal_account_bank_acc_no}
                        destinationIfsc={txn?.internal_account_ifsc_code}
                        sourceIfsc={txn?.owner_account_ifsc_code}
                      />
                      <div className="relative">
                        <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-margin-sm border-primary-bg">
                          <p className="text-font-sm text-text-primary w-full truncate font-normal">
                            <TickerAnimation
                              text={
                                txn.created_on
                                  ? formatDateViewAll(
                                      txn.created_on,
                                      false,
                                      false,
                                    )
                                  : "Not given"
                              }
                            />
                          </p>
                          <div className="w-full flex justify-between items-center">
                            <p className="text-font-xs w-width-md text-text-secondary transform-none  font-normal">
                              Date
                            </p>
                            <div className="z-z-index-overlay absolute right-right-base bottom-px">
                              <SecondaryButton
                                btnText={"Additional details"}
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  openMultiTxnDetailModal();
                                  setTxnId(txn?.txn_id);
                                }}
                                isDisabled={false}
                                enabledBgColor={"var(--text-primary)"}
                                enabledTextColor={"var(--primary-bg)"}
                                icon={
                                  "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <TextWithIcon
                        type="Amount"
                        fontWeight={
                          Number(txn?.owner_account_balance)
                            ? Number(txn?.owner_account_balance) >=
                              Number(txn?.amount)
                              ? "semibold"
                              : "semibold"
                            : "normal"
                        }
                        text={
                          txn?.owner_account_balance !== undefined
                            ? formatTotalBalance(txn?.owner_account_balance)
                                .amount
                            : "Not available"
                        }
                        subText={"Balance"}
                        textColor={
                          txn?.owner_account_balance !== null &&
                          txn?.owner_account_balance !== undefined
                            ? txn?.owner_account_balance === "xxxx.xx" ||
                              Number.isNaN(
                                Number(txn?.owner_account_balance),
                              ) ||
                              Number(txn?.owner_account_balance) >=
                                Number(txn?.amount)
                              ? "var(--settled)"
                              : "var(--failed)"
                            : "var(--text-primary)"
                        }
                        iconComponentArray={[
                          ...(function () {
                            let iconUrl = "";
                            let titleText = "";

                            if (
                              createTransactionBankRefreshLoading &&
                              refreshId === txn?.txn_id
                            ) {
                              iconUrl =
                                "https://q2pay.in/new_assets/gifs/inputloader_white.gif";
                              titleText = "Balance updating";
                            } else if (failedRefreshId.includes(txn?.txn_id)) {
                              iconUrl =
                                "https://q2pay.in/new_assets/common/view_all/error_with_orange_circle.svg";
                              titleText = "Balance fetch failed";
                            } else if (
                              !createTransactionBankRefreshLoading &&
                              refreshId === txn?.txn_id &&
                              txn?.owner_account_id === refreshAnimation &&
                              PrevBalance !== undefined &&
                              Number(txn?.owner_account_balance) !==
                                Number(PrevBalance)
                            ) {
                              if (
                                Number(txn?.owner_account_balance) >
                                Number(PrevBalance)
                              ) {
                                iconUrl =
                                  "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif";
                                titleText = "Balance updated";
                              } else if (
                                Number(txn?.owner_account_balance) <
                                Number(PrevBalance)
                              ) {
                                iconUrl =
                                  "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif";
                                titleText = "Balance updated";
                              }
                            }

                            return iconUrl
                              ? [
                                  {
                                    icon: iconUrl,
                                    title: titleText,
                                    isDisabled: false,
                                  },
                                ]
                              : [];
                          })(),
                          ...(() => {
                            if (service)
                              return [
                                {
                                  icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                                  title: "Refresh balance",
                                  isDisabled: !(
                                    services?.includes("VAccountBalance") ||
                                    services?.includes("Admin")
                                  ),
                                  onClick: (e) => {
                                    if (
                                      !createTransactionBankRefreshLoading ||
                                      refreshId !== txn?.txn_id
                                    ) {
                                      if (
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ) {
                                        handleRefresh(
                                          e,
                                          txn?.owner_account_id,
                                          txn?.txn_id,
                                          txn?.owner_account_balance,
                                        );
                                      } else {
                                        e.stopPropagation();
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "VAccountBalance,Admin",
                                          },
                                        });
                                      }
                                    } else {
                                      e.stopPropagation();
                                    }
                                  },
                                  bgColor: "var(--primary-nav)",
                                },
                              ];
                            return [];
                          })(),
                        ]}
                      />
                      <TextWithIcon
                        text={txn?.labels?.join(", ") || "No labels assigned"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        iconComponentArray={[
                          {
                            icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                          },
                        ]}
                      />
                    </card-body>
                  </CardContainer>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className=" z-z-index-overlay  Qmd:hidden absolute bottom-bottom-base flex w-width-full justify-around items-center bg-Blue-7 rounded-t-border-radius-md py-padding-sm">
          {loading ? (
            <>
              <Loader />
            </>
          ) : (
            <>
              <PrimaryWithIconButton
                btnText="Reject"
                handleFunction={() => handleOpenPopup(transactionFilterID)}
                enabledBgColor="var(--failed)"
                enabledTextColor="var(--text-primary)"
                icon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                iconToBeAlign="right"
              />

              <PrimaryWithIconButton
                btnText="Approve"
                handleFunction={() => handleTxnApproval(transactionFilterID)}
                enabledBgColor="var(--positive-act)"
                enabledTextColor="var(--text-primary)"
                icon={
                  "https://q2pay.in/new_assets/common/view_all/check_mark_white.svg"
                }
                imgColor="var(--text-primary)"
                iconToBeAlign="right"
              />
            </>
          )}
        </div> */}
      </div>
    </>
  );
};

export default InternalMultiApprovalTxnDetails;
